import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-264e21b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Seleccionar periodo de datos de la tabla ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("24H ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("1S ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("1M ")
const _hoisted_6 = { class: "dialog-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        class: "block",
        span: 5
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.startDatePicker,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDatePicker) = $event)),
            type: "datetime",
            format: _ctx.$t('format.dateTime'),
            "start-placeholder": "Start Date",
            style: {"margin-right":"5px"}
          }, null, 8, ["modelValue", "format"]),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.endDatePicker,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDatePicker) = $event)),
            type: "datetime",
            format: _ctx.$t('format.dateTime'),
            "end-placeholder": "End Date",
            style: {"margin-right":"5px"}
          }, null, 8, ["modelValue", "format"]),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "24 horas",
            placement: "bottom-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                id: "btnDayInfoEstimation",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickBtn('btnDayInfoEstimation')))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "1 semana",
            placement: "bottom-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                id: "btnWeekInfoEstimation",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickBtn('btnWeekInfoEstimation')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "1 mes",
            placement: "bottom-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                id: "btnMonthInfoEstimation",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickBtn('btnMonthInfoEstimation')))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.dataView,
            "row-class-name": _ctx.tableRowClassName,
            class: "real-time-table",
            height: "400",
            style: {"width":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "parameter",
                label: _ctx.$t('label.parameters'),
                width: "200px",
                align: "left"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "maximo",
                label: _ctx.$t('label.max'),
                align: "center"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "minimo",
                label: _ctx.$t('label.min'),
                align: "center"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "media",
                label: _ctx.$t('label.average'),
                align: "center",
                "text-align": "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(Number(scope.row.media) ? Number(scope.row.media)?.toFixed(2) : "-"), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "row-class-name"])
        ]),
        _: 1
      })
    ])
  ], 64))
}